import * as Yup from 'yup';

import { termsAndConditionValidation } from '@zen/Accounts/components/forms/FormTermsAndConditionsCheckbox';

export const activateAccountValidation = Yup.object({
  terms: termsAndConditionValidation
});
